import { EcommerceAPI } from "../Client";

export const getProductDiscountApi = async (payload) => {
  try {
    return await EcommerceAPI.get("/product/discount", {
      params: { id: payload?.id },
    });
  } catch (error) {
    throw error;
  }
};

export const updateProductDiscountApi = async (payload) => {
  try {
    const id = payload?.id;

    // The update DTO requires the discount id in the request body. Keep the
    // query parameter as well because the endpoint uses it for record lookup.
    return await EcommerceAPI.put("/product/discount", payload, {
      params: { id },
    });
  } catch (error) {
    throw error;
  }
};

export const createProductDiscountApi = async (payload) => {
  try {
    return await EcommerceAPI.post("/product/discount", payload);
  } catch (error) {
    throw error;
  }
};

export const deleteProductDiscountApi = async (payload) => {
  try {
    return await EcommerceAPI.delete("/product/discount", {
      params: { id: payload?.id },
    });
  } catch (error) {
    throw error;
  }
};

export const toggleProductDiscountApi = async (payload) => {
  try {
    return await EcommerceAPI.put(
      "/product/discount/disable/enable",
      null,
      { params: { id: payload?.id } }
    );
  } catch (error) {
    throw error;
  }
};

export const getProductDiscountsApi = async () => {
  try {
    return await EcommerceAPI.get("/product/discounts");
  } catch (error) {
    throw error;
  }
};
